import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-header-shell',
  templateUrl: './header-shell.component.html',
  styleUrls: ['./header-shell.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderShellComponent {

}
